
import { Vue } from 'vue-class-component';

export default class ImageLoading extends Vue {}
